import type { Song } from "./types";

/** Base tempo of a song in BPM, from the median spacing of its beat grid.
 *  Robust to tempo changes / odd gaps (median, not mean). null if too few beats. */
export function songBpm(song: Song): number | null {
  const beats = song.beats;
  if (!beats || beats.length < 2) return null;
  const deltas: number[] = [];
  for (let i = 1; i < beats.length; i++) {
    const prev = beats[i - 1];
    const cur = beats[i];
    if (prev !== undefined && cur !== undefined) deltas.push(cur - prev);
  }
  if (deltas.length === 0) return null;
  deltas.sort((a, b) => a - b);
  const mid = deltas[Math.floor(deltas.length / 2)];
  if (mid === undefined || mid <= 0) return null;
  return 60 / mid;
}

/** The tempo-control readout: absolute BPM scaled by the multiplier, or a percent
 *  fallback when the song's base BPM is unknown (e.g. nothing loaded yet). */
export function formatTempoLabel(baseBpm: number | null, multiplier: number): string {
  if (baseBpm === null) return `${Math.round(multiplier * 100)}%`;
  return `${Math.round(baseBpm * multiplier)} BPM`;
}
